import React from "react"

import PropTypes from "prop-types"

import {getDataTestId} from "../../utils/stringUtil"
import IconButton, {ICON_BUTTON_VARIANTS} from "../IconButton/iconButton"
import texts from "./texts"

import "./style.scss"

const RemovableItem = ({dataTestId, onRemove, value}) => (
    <div className="removable-item" data-testid={dataTestId || getDataTestId(value, "itemSupprimable")}>
        <span className="removable-item-value">{value}</span>

        <IconButton
            ariaLabel={texts.retirer(value)}
            icon="fa-solid fa-xmark"
            onClick={onRemove}
            variant={ICON_BUTTON_VARIANTS.DEFAULT}
        />
    </div>
)

RemovableItem.propTypes = {
    dataTestId: PropTypes.string,
    onRemove: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
}

export default RemovableItem
